

import React from "react";
import {Skeleton} from "antd";

export default class DefaultLoading extends React.Component {
  render() {
    const {retry, error, pastDelay, timeOut} = this.props;
    return <Skeleton active loading={true} title={false} paragraph={{rows: 8}} />;
  }
}
